module.exports = __webpack_public_path__ + "img/mikesmaps.be452e0e.png";